(function () {
  'use strict';

  angular
      .module('tfc.Products',
      [
        'ui.bootstrap',
        'ngFileUpload',
        'ngSanitize'
      ])
      .config(config);

  // @ngInject
  function config($stateProvider) {
    $stateProvider
  }

})();